import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import localeText from "../../../../locale";
import handleCurrency from "../../../../utilities/CurrencySwitch";
import OrdersTable from "./components/OrdersTable";
import RatingModal from "./components/RatingModal";
import useOrders from "./hooks/useOrders";

const Orders = (props) => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const {
    isLoading: loading,
    orders,
    confirmReceivedVisible,
    currentOrder,
    parcelInfo,
    confirmSendVisible,
    displayRateVisible,
    ratingSeller,
    ratingProduct,
    comment,
    commentProductService,
    shippingCompany,
    trackingObject,
    displayRegisterPickupVisible,
    storeName,
    filterByStoreName,
    setStoreName,
    setRatingSeller,
    setRatingProduct,
    setConfirmSendVisible,
    setOrderId_,
    setConfirmReceivedVisible,
    setDisplayRateVisible,
    setComment,
    setCommentProductService,
    setCurrency,
    setShippingCompany,
    setTrackingObject,
    setDisplayRegisterPickupVisible,
    registerPickup,
    orderRate,
    sendOrder,
    receiveOrder,
    setCurrentOrder,
  } = useOrders({
    sales: props.sales,
    admin: props.admin,
    onErrorLoadAdminOrders: (code) => showErrorToast({ code }),
    onErrorLoadUserOrders: (code) => showErrorToast({ code }),
    onErrorReceiveOrder: (code) => showErrorToast({ code }),
    onErrorSendOrder: (code) => showErrorToast({ code }),
    onErrorFillOutAll: () => showErrorToast({ detail: "pleaseFillOutAll" }),
    onErrorDownloadProducts: (code) => showErrorToast({ code }),
    onErrorGetParcel: (code) => showErrorToast({ code }),
    onErrorProvideRating: () => showErrorToast({ detail: "pleaseProvideRating" }),
    onErrorOrderRate: (code) => showErrorToast({ code }),
    onErrorValidatePickup: () => showErrorToast({ detail: "dateMustNotBeNull" }),
    onErrorRegisterPickup: (code) => showErrorToast({ code }),
    onSuccessSendOrder: () => showSuccessToast({ detail: "productSentSuccessfully" }),
    onSuccessReceiveOrder: () => showSuccessToast({ detail: "productReceivedSuccessfully" }),
    onSuccessOrderRate: () => showSuccessToast({ detail: "orderRatedSuccessfully" }),
  });

  return (
    <>
      {props.sales && props.plan === "Promoter" ? (
        <div className="card border-1 border-300">
          <div className="text-center">
            <i className="pi pi-lock text-8xl text-400 my-4"></i>
            <h2 className="my-6">{localeText("planNotAllowed")}</h2>
          </div>
        </div>
      ) : (
        <div>
          <RatingModal
            comment={comment}
            commentProductService={commentProductService}
            setCommentProductService={setCommentProductService}
            displayRateVisible={displayRateVisible}
            loading={loading}
            orderRate={orderRate}
            ratingProduct={ratingProduct}
            ratingSeller={ratingSeller}
            setComment={setComment}
            setDisplayRateVisible={setDisplayRateVisible}
            setRatingProduct={setRatingProduct}
            setRatingSeller={setRatingSeller}
          />

          <ConfirmDialog
            visible={confirmReceivedVisible}
            onHide={() => setConfirmReceivedVisible(false)}
            message={() => {
              return (
                <>
                  {loading ? (
                    <div className="text-center">
                      <i className="pi pi-spin pi-spinner text-8xl text-500 my-6"></i>
                    </div>
                  ) : (
                    <>
                      {currentOrder && !currentOrder.itens[0].product.downloadable ? (
                        <>{localeText("receiveThisOrder")}</>
                      ) : (
                        <>{localeText("receiveDownloadLinksConfirmation")}</>
                      )}
                    </>
                  )}
                </>
              );
            }}
            header={localeText("confirmYourAction")}
            icon="pi pi-exclamation-triangle"
            accept={() => receiveOrder(currentOrder.buyer.username, currentOrder.id)}
            reject={() => setConfirmReceivedVisible(false)}
            acceptLabel={localeText("confirm")}
            rejectLabel={localeText("cancel")}
          />

          <ConfirmDialog
            visible={displayRegisterPickupVisible}
            onHide={() => setDisplayRegisterPickupVisible(false)}
            message={() => {
              return <>{localeText("registerPickupConfirmation")}</>;
            }}
            header={localeText("confirmYourAction")}
            icon="pi pi-exclamation-triangle"
            accept={() => registerPickup()}
            reject={() => setDisplayRegisterPickupVisible(false)}
            acceptLabel={localeText("confirm")}
            rejectLabel={localeText("cancel")}
          />

          <ConfirmDialog
            visible={confirmSendVisible}
            onHide={() => setConfirmSendVisible(false)}
            message={() => {
              return (
                <>
                  {loading ? (
                    <div className="text-center">
                      <i className="pi pi-spin pi-spinner text-8xl text-500 my-6"></i>
                    </div>
                  ) : (
                    <>
                      {currentOrder?.itens[0]?.product?.subCategory?.service ? (
                        <p>{localeText("confirmOrderWasSent2")}</p>
                      ) : (
                        <>
                          {localeText("confirmOrderWasSent")}
                          <ul className="list-none mx-0 mt-4 p-0">
                            <li>
                              <label htmlFor="shipping">{localeText("shippingCompany")}:</label>
                            </li>
                            <li>
                              <InputText
                                className="mt-2 w-full"
                                name="shipping"
                                value={shippingCompany}
                                disabled={parcelInfo?.shippingMethods?.name ? true : false}
                                onChange={(e) => setShippingCompany(e.target.value)}
                              />
                            </li>
                            <li className="mt-2">
                              <label htmlFor="tracking">{localeText("trackingObject")}:</label>
                            </li>
                            <li>
                              <InputText
                                className="mt-2 w-full"
                                name="tracking"
                                value={trackingObject}
                                disabled={parcelInfo?.trackingNumber ? true : false}
                                onChange={(e) => setTrackingObject(e.target.value)}
                              />
                            </li>
                          </ul>
                        </>
                      )}
                    </>
                  )}
                </>
              );
            }}
            header={localeText("sendOrder")}
            icon="pi pi-exclamation-triangle"
            accept={() => {
              sendOrder(
                localStorage.getItem("__extraconomy_username"),
                currentOrder.id,
                shippingCompany,
                trackingObject
              );
            }}
            reject={() => setConfirmSendVisible(false)}
            acceptLabel={localeText("confirm")}
            rejectLabel={localeText("cancel")}
          />

          <div className="card border-1 border-300">
            {!props.admin ? (
              <>
                {props.sales ? (
                  <>
                    <h3 className="my-4">{localeText("sales")}</h3>
                    <hr />
                  </>
                ) : (
                  <>
                    <h3 className="my-4">{localeText("purchases")}</h3>
                    <hr />
                  </>
                )}
              </>
            ) : (
              <>
                <h3 className="my-4">{localeText("orders")}</h3>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "justify-content",
                    alignItems: "center",
                  }}
                >
                  <InputText
                    className="w-100"
                    name="tracking"
                    value={storeName}
                    onChange={(e) => {
                      setStoreName(e.target.value);
                    }}
                    placeholder={localeText("searchByStoreName")}
                  />
                  <Button
                    icon={<i className="pi pi-search text-xl"></i>}
                    style={{ color: "#46a748" }}
                    rounded
                    text
                    onClick={filterByStoreName}
                  />
                </div>
                <hr />
              </>
            )}

            <OrdersTable
              admin={props.admin}
              sales={props.sales}
              orders={orders}
              handleCurrency={handleCurrency}
              loading={loading}
              setCurrency={setCurrency}
              setCurrentOrder={setCurrentOrder}
              setOrderId_={setOrderId_}
              setDisplayRateVisible={setDisplayRateVisible}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Orders;
